/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Law10Inputs */

const en__field__enum_primarystudyinterest_study_law10 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Law10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Law`)
};

const de__field__enum_primarystudyinterest_study_law10 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Law10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtswissenschaft`)
};

/**
* | output |
* | --- |
* | "Law" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Law10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_law10 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Law10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Law10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_law10(inputs)
	return de__field__enum_primarystudyinterest_study_law10(inputs)
});
export { _field__enum_primarystudyinterest_study_law10 as "_field__enum_primaryStudyInterest_STUDY_LAW" }